import { useMemo } from "react";
import {
  BIKE_FEE_PERCENT_CALCULATOR,
  BIKE_FREQUENCY_CALCULATOR,
  bikeCalculate,
  IBikeCalculatorValues,
} from "../helpers/bike-calculations";

const useBikeCalculations = (
  voucher: number,
  salary: number,
  frequency: number = BIKE_FREQUENCY_CALCULATOR,
  fee: number = BIKE_FEE_PERCENT_CALCULATOR
): IBikeCalculatorValues => {
  const calculatorValues = useMemo(() => {
    return bikeCalculate(voucher, salary, frequency, fee);
  }, [fee, frequency, voucher, salary]);

  return calculatorValues;
};

export default useBikeCalculations;
